require('particles.js');

particlesJS.load('particles-js', 'assets/particle.json');